import React from 'react';
import Projects from '../components/sections/Projects';
import styles from './ProjectsPage.module.css';

const ProjectsPage: React.FC = () => {
  return (
    <div className={styles.projectsPage}>
      <Projects />
    </div>
  );
};

export default ProjectsPage;
